import {
  ResetPasswordVerifyOtpBodyType,
  ResetPasswordVerifyOtpResponseType
} from "@website/widget/login/services/reset-password-verify-otp/reset-password-verify-otp.types";
import { BASE_URL_PROFILE } from "@website/widget/login/services/urls";
import { Axios } from "@website/widget/login/utils";
import { AxiosResponse } from "axios";

export const ResetpasswordVerifyOtpUrl = `${BASE_URL_PROFILE}/reset-password/verify-otp`;

export const ResetPasswordVerifyOtpService = (
  body: ResetPasswordVerifyOtpBodyType
): Promise<ResetPasswordVerifyOtpResponseType> =>
  Axios.post(ResetpasswordVerifyOtpUrl, body).then(
    ({ data }: AxiosResponse<ResetPasswordVerifyOtpResponseType>) => data
  );
